"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n    position: absolute;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var base = function base(_ref) {
  var theme = _ref.theme,
      dirLeft = _ref.dirLeft;
  var palette = theme.palette;
  return _objectSpread({
    top: "calc(100% + ".concat(palette.gutter / 2, "px)"),
    background: theme.listBackground,
    boxShadow: theme.listBoxShadow,
    padding: "".concat(palette.gutter, "px 0"),
    zIndex: theme.listZIndex
  }, dirLeft ? {
    left: 0,
    right: 'auto'
  } : {
    right: 0,
    left: 'auto'
  });
};

var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
});

var _default = Root;
exports["default"] = _default;